import * as React from 'react';
import { makeStyles, shorthands, Spinner } from '@fluentui/react-components';

export function CenteredLoadingSpinner() {
  const classes = useStyles();

  return <Spinner size="large" className={classes.root} />;
}

const useStyles = makeStyles({
  root: {
    ...shorthands.margin('auto'),
    alignSelf: 'center',
  },
});
